module.exports = __webpack_public_path__ + "img/cover.6ffdbe27.jpg";